// extracted by mini-css-extract-plugin
export var displayNone = "_v3-6";
export var imgContainer = "_v3-2";
export var overflowHidden = "_v3-3";
export var productInfoCardButtonContainer = "_v3-5";
export var productTitleText = "_v3-4";
export var rightArrow = "_v3-1";
export var rightArrowContainer = "_v3-0";